"use client";

import { ApplicationState } from "@/types/application-state";
import { Resource } from "@/types/epc-interfaces";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export const useEllimae = create<ApplicationState>()(
  devtools(
    persist(
      (set) => ({
        isUat: false,
        isUatChecked: false,
        token: null,
        loading: false,
        initialized: false,
        transactionId: null,
        setEllimaeState: (newState: Partial<ApplicationState>) =>
          set((state) => ({ ...state, ...newState })),
        setLoading: (loading: boolean) => set(() => ({ loading })),
        setResources: (resources: Resource[] | null) =>
          set(() => ({ resources })),
        setIsUAT: (isUat: boolean) => set(() => ({ isUat })),
        setIsUATChecked: (isChecked: boolean) =>
          set(() => ({ isUatChecked: isChecked })),
      }),
      {
        name: "ellimae-session",
        partialize: (state) => ({
          isUat: state.isUat,
        }),
        storage: createJSONStorage(() => sessionStorage),
        version: 2,
      },
    ),
    { name: "EllimaeStore" },
  ),
);
